<template>
  <section
    v-if="slice.JotformId"
    class="ct-jotform"
  >
    <ThirdpartyJotform
      :jotform-id="slice.JotformId"
      :jotform-title="slice.Title"
    />
  </section>
</template>

<script lang="ts" setup>
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})
</script>
